import { integrationMiddleware } from "../network/middlewareHttp";
import { baseURL } from "./FetchUrl";

class StorageDetails{
    apiURL = baseURL
    getEndpoint = '/api/storaged/get'
    postEndpoint = '/api/storaged/post'
    putEndpoint = '/api/storaged/put'
    deleteEndpoint = '/api/storaged/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')
    
    getStorageDetailsList = async() => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint)
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postStorageDetails = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteStorageDetails = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateStorageDetails = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default StorageDetails
